import {
  init_WorldFilled
} from "./chunk-YBOUJ3WD.mjs";
import {
  init_WorldOutline
} from "./chunk-AM6PCOAK.mjs";
import {
  init_ZoomInFilled
} from "./chunk-R4WPUPGG.mjs";
import {
  init_ZoomInOutline
} from "./chunk-2E3F2X4N.mjs";
import {
  init_ZoomOutFilled
} from "./chunk-J3IATMUF.mjs";
import {
  init_ZoomOutOutline
} from "./chunk-TRPSZWSM.mjs";
import {
  init_VegetarianFilled
} from "./chunk-FL4N7J3U.mjs";
import {
  init_VegetarianOutline
} from "./chunk-BMJVXEWM.mjs";
import {
  init_VenueFilled
} from "./chunk-TAQYAHBK.mjs";
import {
  init_VenueOutline
} from "./chunk-USCAGQIT.mjs";
import {
  init_WalletFilled
} from "./chunk-QK3NSM2V.mjs";
import {
  init_WalletOutline
} from "./chunk-XVOJCUYI.mjs";
import {
  init_WarningFilled
} from "./chunk-LLOSH46T.mjs";
import {
  init_WarningOutline
} from "./chunk-ZXSMN3GH.mjs";
import {
  init_UserGroupOutline
} from "./chunk-E3D4DDMT.mjs";
import {
  init_UserOutline
} from "./chunk-7PFDEOL3.mjs";
import {
  init_UserRemoveFilled
} from "./chunk-M4IIWYH7.mjs";
import {
  init_UserRemoveOutline
} from "./chunk-BEKYHE5M.mjs";
import {
  init_UserVipFilled
} from "./chunk-6FYI3BSF.mjs";
import {
  init_UserVipOutline
} from "./chunk-LL3COX47.mjs";
import {
  init_VeganFilled
} from "./chunk-WKQM2A5J.mjs";
import {
  init_VeganOutline
} from "./chunk-OZH7SFUF.mjs";
import {
  init_UserAddFilled
} from "./chunk-FP3AP7OP.mjs";
import {
  init_UserAddOutline
} from "./chunk-UBPPSGEY.mjs";
import {
  init_UserCircleFilled
} from "./chunk-6Q2Q7T6D.mjs";
import {
  init_UserCircleOutline
} from "./chunk-4N2Z2WFR.mjs";
import {
  init_UserFilled
} from "./chunk-OAVX2HWA.mjs";
import {
  init_UserFollowFilled
} from "./chunk-MEOGHBQF.mjs";
import {
  init_UserFollowOutline
} from "./chunk-PRA6DBQH.mjs";
import {
  init_UserGroupFilled
} from "./chunk-ILHYECOM.mjs";
import {
  init_UndoFilled
} from "./chunk-NR2YPGCV.mjs";
import {
  init_UndoOutline
} from "./chunk-SZUBLBWW.mjs";
import {
  init_UnlockFilled
} from "./chunk-LCVDAT4T.mjs";
import {
  init_UnlockOutline
} from "./chunk-FK2H4F3R.mjs";
import {
  init_UploadCloudFilled
} from "./chunk-MUY43HNE.mjs";
import {
  init_UploadCloudOutline
} from "./chunk-JH77TTGC.mjs";
import {
  init_UploadFilled
} from "./chunk-FCYCL5OJ.mjs";
import {
  init_UploadOutline
} from "./chunk-PLEOLY5W.mjs";
import {
  init_TakeAwayOutline
} from "./chunk-XSZ6KEZA.mjs";
import {
  init_ThumbsDownFilled
} from "./chunk-LC5XGRCJ.mjs";
import {
  init_ThumbsDownOutline
} from "./chunk-KIBMFTVU.mjs";
import {
  init_ThumbsUpFilled
} from "./chunk-ZOK35N2A.mjs";
import {
  init_ThumbsUpOutline
} from "./chunk-P7RQN7SM.mjs";
import {
  init_Tick
} from "./chunk-HWQYTGRZ.mjs";
import {
  init_TimerFilled
} from "./chunk-IFTSMHZM.mjs";
import {
  init_TimerOutline
} from "./chunk-4JQV436V.mjs";
import {
  init_StopOutline
} from "./chunk-VWNHNHXF.mjs";
import {
  init_SuccessFilled
} from "./chunk-5YXGXDAR.mjs";
import {
  init_SuccessOutline
} from "./chunk-GMCAWS2T.mjs";
import {
  init_SupportFilled
} from "./chunk-3DF3Q2IT.mjs";
import {
  init_SupportOutline
} from "./chunk-NQ4COXRX.mjs";
import {
  init_TagFilled
} from "./chunk-YH5MOHJB.mjs";
import {
  init_TagOutline
} from "./chunk-IHTZ4SGI.mjs";
import {
  init_TakeAwayFilled
} from "./chunk-AWUXILEC.mjs";
import {
  init_SortAscOutline
} from "./chunk-LVS44IEK.mjs";
import {
  init_SortDescOutline
} from "./chunk-ZZQLOAYZ.mjs";
import {
  init_SparkleFilled
} from "./chunk-DO3IM7RA.mjs";
import {
  init_SparkleOutline
} from "./chunk-TU44KREG.mjs";
import {
  init_StarFilled
} from "./chunk-2RSEHV5O.mjs";
import {
  init_StarHalf
} from "./chunk-6H4XQ2K4.mjs";
import {
  init_StarOutline
} from "./chunk-VRAAPWUZ.mjs";
import {
  init_StopFilled
} from "./chunk-3YPZRZ36.mjs";
import {
  init_ShareFilled
} from "./chunk-7RGPY7PJ.mjs";
import {
  init_ShareOutline
} from "./chunk-S5YTMJVX.mjs";
import {
  init_ShieldFilled
} from "./chunk-7N7ZTYKN.mjs";
import {
  init_ShieldOutline
} from "./chunk-ATRQB7PI.mjs";
import {
  init_ShoppingBagFilled
} from "./chunk-RABVAJH6.mjs";
import {
  init_ShoppingBagOutline
} from "./chunk-GLZXFTFV.mjs";
import {
  init_SidebarFilled
} from "./chunk-TD2ZW5XJ.mjs";
import {
  init_SidebarOutline
} from "./chunk-ILQKAAKX.mjs";
import {
  init_SearchFilled
} from "./chunk-3YQXMCNO.mjs";
import {
  init_SearchOutline
} from "./chunk-XDAG2GRV.mjs";
import {
  init_SecureFilled
} from "./chunk-WNC6FEMB.mjs";
import {
  init_SecureOutline
} from "./chunk-VMRZBCMW.mjs";
import {
  init_SendFilled
} from "./chunk-FXB43MSM.mjs";
import {
  init_SendOutline
} from "./chunk-Z34RUDDX.mjs";
import {
  init_SettingsFilled
} from "./chunk-ULC5WDPM.mjs";
import {
  init_SettingsOutline
} from "./chunk-O5FKSTRG.mjs";
import {
  init_ReceiptFilled
} from "./chunk-KLRDRI5W.mjs";
import {
  init_ReceiptOutline
} from "./chunk-UDR77GJI.mjs";
import {
  init_RefreshFilled
} from "./chunk-OAZDCY35.mjs";
import {
  init_RefreshOutline
} from "./chunk-EK4B2BT2.mjs";
import {
  init_ScaleFilled
} from "./chunk-IEECVY45.mjs";
import {
  init_ScaleOutline
} from "./chunk-SHQ2JQ5G.mjs";
import {
  init_ScanFilled
} from "./chunk-HMS5FA3M.mjs";
import {
  init_ScanOutline
} from "./chunk-LEH66UQ3.mjs";
import {
  init_PrivacyFilled
} from "./chunk-BNHGPI7A.mjs";
import {
  init_PrivacyOutline
} from "./chunk-FA53ZWDC.mjs";
import {
  init_QrCodeFilled
} from "./chunk-AGTEFD7U.mjs";
import {
  init_QrCodeOutline
} from "./chunk-GIZTS2FW.mjs";
import {
  init_QuestionFilled
} from "./chunk-CJZQPMOM.mjs";
import {
  init_QuestionOutline
} from "./chunk-YC4MGHCE.mjs";
import {
  init_ReceiptAltFilled
} from "./chunk-XQMYD4S5.mjs";
import {
  init_ReceiptAltOutline
} from "./chunk-6ORRKSQL.mjs";
import {
  init_PhoneFilled
} from "./chunk-NKYODFGN.mjs";
import {
  init_PhoneOutline
} from "./chunk-OJMVFCC7.mjs";
import {
  init_PinFilled
} from "./chunk-KIV4HH3C.mjs";
import {
  init_PinOutline
} from "./chunk-2Q5HBKEJ.mjs";
import {
  init_PrinterCloudFilled
} from "./chunk-VPEVN6SB.mjs";
import {
  init_PrinterCloudOutline
} from "./chunk-YPTVK4HZ.mjs";
import {
  init_PrinterFilled
} from "./chunk-JARODNVT.mjs";
import {
  init_PrinterOutline
} from "./chunk-IJHI77ID.mjs";
import {
  init_NutFilled
} from "./chunk-3PPVUKYG.mjs";
import {
  init_NutOutline
} from "./chunk-H3JX3DBS.mjs";
import {
  init_PageFilled
} from "./chunk-FESV3GKR.mjs";
import {
  init_PageOutline
} from "./chunk-WI7TIQLZ.mjs";
import {
  init_PaperFilled
} from "./chunk-KVDQMCM4.mjs";
import {
  init_PaperOutline
} from "./chunk-RVFSJTQ5.mjs";
import {
  init_PercentageFilled
} from "./chunk-ZA7ITIFJ.mjs";
import {
  init_PercentageOutline
} from "./chunk-GSZAS2NQ.mjs";
import {
  init_MenuAlt
} from "./chunk-BJ4KYZM4.mjs";
import {
  init_Minus
} from "./chunk-UP5QBXOO.mjs";
import {
  init_MinusCircleFilled
} from "./chunk-BJJMPFJM.mjs";
import {
  init_MinusCircleOutline
} from "./chunk-OEI43YMG.mjs";
import {
  init_MoreHorizontal
} from "./chunk-ZPYS4EAE.mjs";
import {
  init_MoreVertical
} from "./chunk-SRWJ4OV5.mjs";
import {
  init_NavFilled
} from "./chunk-7V6YVBH5.mjs";
import {
  init_NavOutline
} from "./chunk-JBGIXM2O.mjs";
import {
  init_MailOutline
} from "./chunk-XV4GLIHL.mjs";
import {
  init_MapFilled
} from "./chunk-H5OTOKNG.mjs";
import {
  init_MapOutline
} from "./chunk-KIWL4K6I.mjs";
import {
  init_MapPinFilled
} from "./chunk-DCGICBJT.mjs";
import {
  init_MapPinOutline
} from "./chunk-S7JOLCPC.mjs";
import {
  init_MapPinsFilled
} from "./chunk-37ET557C.mjs";
import {
  init_MapPinsOutline
} from "./chunk-GUQ4CKM5.mjs";
import {
  init_Menu
} from "./chunk-P47E2KMI.mjs";
import {
  init_LockOutline
} from "./chunk-AYCMJAUI.mjs";
import {
  init_LoginFilled
} from "./chunk-GNECEZGB.mjs";
import {
  init_LoginOutline
} from "./chunk-H4WSJPFU.mjs";
import {
  init_LogoutFilled
} from "./chunk-HNDEGMHV.mjs";
import {
  init_LogoutOutline
} from "./chunk-6RCGUNKB.mjs";
import {
  init_MailAddFilled
} from "./chunk-G742CPZM.mjs";
import {
  init_MailAddOutline
} from "./chunk-HOGE5EKP.mjs";
import {
  init_MailFilled
} from "./chunk-364U25KY.mjs";
import {
  init_LightbulbFilled
} from "./chunk-SZFDLFAB.mjs";
import {
  init_LightbulbOutline
} from "./chunk-4INXAO6V.mjs";
import {
  init_LinkOutline
} from "./chunk-JOIPM22L.mjs";
import {
  init_LinkUnlinkOutline
} from "./chunk-SUHTMWG2.mjs";
import {
  init_ListCheck3Filled
} from "./chunk-QI3P7RGD.mjs";
import {
  init_ListIndefiniteFilled
} from "./chunk-WXITUDTX.mjs";
import {
  init_ListSettingsFilled
} from "./chunk-FVUUYNZ6.mjs";
import {
  init_LockFilled
} from "./chunk-5QEOKQPI.mjs";
import {
  init_InfoFilled
} from "./chunk-C7PAFQ5B.mjs";
import {
  init_InfoOutline
} from "./chunk-KTPBUN4O.mjs";
import {
  init_KeyFilled
} from "./chunk-EM5GOCHS.mjs";
import {
  init_KeyOutline
} from "./chunk-E6PS3BLJ.mjs";
import {
  init_KnifeFilled
} from "./chunk-6EPQ3VMQ.mjs";
import {
  init_KnifeOutline
} from "./chunk-YYQC2UAB.mjs";
import {
  init_LeafFilled
} from "./chunk-NV23BAZB.mjs";
import {
  init_LeafOutline
} from "./chunk-TWVJDODR.mjs";
import {
  init_HomeFilled
} from "./chunk-HB3EIU5G.mjs";
import {
  init_HomeOutline
} from "./chunk-ASY7CZDR.mjs";
import {
  init_HotelFilled
} from "./chunk-QDGBJGD2.mjs";
import {
  init_HotelOutline
} from "./chunk-SOINQ4SR.mjs";
import {
  init_ImageAddFilled
} from "./chunk-EFJKMFPC.mjs";
import {
  init_ImageAddOutline
} from "./chunk-FOWLNGFJ.mjs";
import {
  init_ImportPosFilled
} from "./chunk-YQGFTKIB.mjs";
import {
  init_ImportPosOutline
} from "./chunk-K6AORNWK.mjs";
import {
  init_GlutenFreeOutline
} from "./chunk-RKARMECT.mjs";
import {
  init_GridFilled
} from "./chunk-32ETYXO2.mjs";
import {
  init_GridOutline
} from "./chunk-SMW4NNSC.mjs";
import {
  init_Hashtag
} from "./chunk-P2UHM3U6.mjs";
import {
  init_HeartFilled
} from "./chunk-UF36WADW.mjs";
import {
  init_HeartOutline
} from "./chunk-UOODJEQT.mjs";
import {
  init_HistoryFilled
} from "./chunk-PZK4JUNF.mjs";
import {
  init_HistoryOutline
} from "./chunk-O2LP5QLP.mjs";
import {
  init_FolderOutline
} from "./chunk-BGE7JE5T.mjs";
import {
  init_ForwardFilled
} from "./chunk-SONPMJVB.mjs";
import {
  init_ForwardOutline
} from "./chunk-IN4MZLXW.mjs";
import {
  init_GiftFilled
} from "./chunk-GIQQDLNY.mjs";
import {
  init_GiftOutline
} from "./chunk-VZXMMNSK.mjs";
import {
  init_GiveFilled
} from "./chunk-VVLY57JF.mjs";
import {
  init_GiveOutline
} from "./chunk-26GYXSXO.mjs";
import {
  init_GlutenFreeFilled
} from "./chunk-U4JSDTCT.mjs";
import {
  init_EyeOnOutline
} from "./chunk-XAWF5RFM.mjs";
import {
  init_FilterFilled
} from "./chunk-SJZCNOHS.mjs";
import {
  init_FilterOutline
} from "./chunk-EEHBB7P3.mjs";
import {
  init_FlagFilled
} from "./chunk-OY4EHMG4.mjs";
import {
  init_FlagOutline
} from "./chunk-4E2VV2GN.mjs";
import {
  init_FolderFilled
} from "./chunk-MIJ3BEQY.mjs";
import {
  init_FolderInfoFilled
} from "./chunk-LY4ZHDO3.mjs";
import {
  init_FolderInfoOutline
} from "./chunk-R4PSPWG2.mjs";
import {
  init_ErrorOutline
} from "./chunk-FWUMX7L2.mjs";
import {
  init_ExpandFilled
} from "./chunk-6BLSF6YD.mjs";
import {
  init_ExternalLinkFilled
} from "./chunk-6TXNNJHG.mjs";
import {
  init_ExternalLinkOutline
} from "./chunk-QASJAURM.mjs";
import {
  init_EyeOff2Outline
} from "./chunk-SJ7ATOUL.mjs";
import {
  init_EyeOffFilled
} from "./chunk-PO76JBHS.mjs";
import {
  init_EyeOffOutline
} from "./chunk-6XFOLKGF.mjs";
import {
  init_EyeOnFilled
} from "./chunk-TGFTNQAT.mjs";
import {
  init_DownloadCloudFilled
} from "./chunk-YS47ISJ3.mjs";
import {
  init_DownloadCloudOutline
} from "./chunk-Y6PJFBW5.mjs";
import {
  init_DownloadFilled
} from "./chunk-BM6CZ46L.mjs";
import {
  init_DownloadOutline
} from "./chunk-NPAXZ6TX.mjs";
import {
  init_DraggableFilled
} from "./chunk-5EIIK4YK.mjs";
import {
  init_EditFilled
} from "./chunk-ULCTWFGT.mjs";
import {
  init_EditOutline
} from "./chunk-K5Q36PWK.mjs";
import {
  init_ErrorFilled
} from "./chunk-YTKEFUAN.mjs";
import {
  init_CutleryAltFilled
} from "./chunk-AEZJUGH6.mjs";
import {
  init_CutleryAltOutline
} from "./chunk-3RNZX5E4.mjs";
import {
  init_CutleryFilled
} from "./chunk-IMHVR24N.mjs";
import {
  init_CutleryOutline
} from "./chunk-C43TREW2.mjs";
import {
  init_DiscountFilled
} from "./chunk-IAOXD2PE.mjs";
import {
  init_DiscountOutline
} from "./chunk-ZUNPIN7Q.mjs";
import {
  init_DocWarningFilled
} from "./chunk-SXN6HNBR.mjs";
import {
  init_DocWarningOutline
} from "./chunk-5MW3VSS7.mjs";
import {
  init_CoinFilled
} from "./chunk-QESGN356.mjs";
import {
  init_CoinOutline
} from "./chunk-EF3GS3P2.mjs";
import {
  init_CopyFilled
} from "./chunk-MULPTNVD.mjs";
import {
  init_CopyOutline
} from "./chunk-MKU6ZEK7.mjs";
import {
  init_CouponFilled
} from "./chunk-VEZTEV6X.mjs";
import {
  init_CouponOutline
} from "./chunk-DRWA3FRA.mjs";
import {
  init_CrownFilled
} from "./chunk-55CFAGUW.mjs";
import {
  init_CrownOutline
} from "./chunk-2YHDSGJW.mjs";
import {
  init_ClockOutline
} from "./chunk-KQ5PVA5D.mjs";
import {
  init_Close
} from "./chunk-QIV5MHQM.mjs";
import {
  init_ClosedFilled
} from "./chunk-KRETDS7B.mjs";
import {
  init_ClosedOutline
} from "./chunk-6D3QC7ZH.mjs";
import {
  init_CocktailFilled
} from "./chunk-3VJE5Z3A.mjs";
import {
  init_CocktailOutline
} from "./chunk-D5QZ2572.mjs";
import {
  init_CoffeeFilled
} from "./chunk-E4PIO457.mjs";
import {
  init_CoffeeOutline
} from "./chunk-YJYFPDH5.mjs";
import {
  init_ChevronLeft
} from "./chunk-KCROL6NO.mjs";
import {
  init_ChevronRight
} from "./chunk-CEADDC3I.mjs";
import {
  init_ChevronSmallDown
} from "./chunk-3S6FXNVR.mjs";
import {
  init_ChevronSmallLeft
} from "./chunk-7HWD7HQR.mjs";
import {
  init_ChevronSmallRight
} from "./chunk-7BUEGFDG.mjs";
import {
  init_ChevronSmallUp
} from "./chunk-LLVAT2PY.mjs";
import {
  init_ChevronUp
} from "./chunk-3XLJMH6C.mjs";
import {
  init_ClockFilled
} from "./chunk-WGWFPGFA.mjs";
import {
  init_ChatGroupOutline
} from "./chunk-NA2F5GSM.mjs";
import {
  init_ChatOutline
} from "./chunk-US3VPODM.mjs";
import {
  init_ChatSmileFilled
} from "./chunk-OU4AWMLY.mjs";
import {
  init_ChatSmileOutline
} from "./chunk-3DMBVQH4.mjs";
import {
  init_ChatSuccessFilled
} from "./chunk-YAXR2MTZ.mjs";
import {
  init_ChatSuccessOutline
} from "./chunk-WM5QFIF3.mjs";
import {
  init_CheckListFilled
} from "./chunk-GLEQ3PGR.mjs";
import {
  init_ChevronDown
} from "./chunk-TQ2U7EMJ.mjs";
import {
  init_ChartBarFilled
} from "./chunk-D4OD2ZK5.mjs";
import {
  init_ChartBarOutline
} from "./chunk-XJXX264Z.mjs";
import {
  init_ChartGrowthFilled
} from "./chunk-4DS4QNEE.mjs";
import {
  init_ChartGrowthOutline
} from "./chunk-ZC5FBI6G.mjs";
import {
  init_ChartPieFilled
} from "./chunk-2JT7Z743.mjs";
import {
  init_ChartPieOutline
} from "./chunk-6FYVS6CS.mjs";
import {
  init_ChatFilled
} from "./chunk-H3DLNDRQ.mjs";
import {
  init_ChatGroupFilled
} from "./chunk-TLNDBY2C.mjs";
import {
  init_CakeFilled
} from "./chunk-6SY6MKX6.mjs";
import {
  init_CakeOutline
} from "./chunk-645S2ZV2.mjs";
import {
  init_CalendarFilled
} from "./chunk-4NS6QZDC.mjs";
import {
  init_CalendarOutline
} from "./chunk-KUYA6KWK.mjs";
import {
  init_CardFilled
} from "./chunk-XATWE2F6.mjs";
import {
  init_CardOutline
} from "./chunk-KOE2CWHJ.mjs";
import {
  init_CartFilled
} from "./chunk-M5CFTVTK.mjs";
import {
  init_CartOutline
} from "./chunk-HBF37FPV.mjs";
import {
  init_BookmarkFilled
} from "./chunk-ECCMRXL3.mjs";
import {
  init_BookmarkOutline
} from "./chunk-U32YE6JO.mjs";
import {
  init_BottleFilled
} from "./chunk-TXJBU566.mjs";
import {
  init_BottleOutline
} from "./chunk-2PY3ZCJG.mjs";
import {
  init_BrowserFilled
} from "./chunk-R5P6MIFT.mjs";
import {
  init_BrowserOutline
} from "./chunk-SLLYS2TA.mjs";
import {
  init_BuildingFilled
} from "./chunk-NMDDHJTA.mjs";
import {
  init_BuildingOutline
} from "./chunk-PSQCYKCU.mjs";
import {
  init_ArrowRightUp
} from "./chunk-EBVOYFDZ.mjs";
import {
  init_ArrowUp
} from "./chunk-P77RSXSJ.mjs";
import {
  init_BellFilled
} from "./chunk-DZV5GQNX.mjs";
import {
  init_BellOutline
} from "./chunk-YSKCYLP5.mjs";
import {
  init_BinFilled
} from "./chunk-IXMNUHHU.mjs";
import {
  init_BinOutline
} from "./chunk-X5MPENNF.mjs";
import {
  init_BlockedFilled
} from "./chunk-GDVIZ6SH.mjs";
import {
  init_BlockedOutline
} from "./chunk-GE4LN5CL.mjs";
import {
  init_AlertFilled
} from "./chunk-BK3HQ2IL.mjs";
import {
  init_AlertOutline
} from "./chunk-NHG7MXXJ.mjs";
import {
  init_ArrowDown
} from "./chunk-2YHFCATA.mjs";
import {
  init_ArrowLeft
} from "./chunk-D5XLNYTM.mjs";
import {
  init_ArrowLeftDown
} from "./chunk-25MI6KHV.mjs";
import {
  init_ArrowLeftUp
} from "./chunk-A2TUVSKO.mjs";
import {
  init_ArrowRight
} from "./chunk-A7AMBEHJ.mjs";
import {
  init_ArrowRightDown
} from "./chunk-5KTVZYEI.mjs";
import {
  init_Add
} from "./chunk-UDU5MILV.mjs";
import {
  init_AddCircleFilled
} from "./chunk-VFJ3AZ7H.mjs";
import {
  init_AddCircleOutline
} from "./chunk-GQOCBVCD.mjs";
import {
  init_AddressBookFilled
} from "./chunk-M7BWAMGC.mjs";
import {
  init_AddressBookOutline
} from "./chunk-F3OG7SMS.mjs";
import {
  init_AlarmFilled
} from "./chunk-DQYTP77D.mjs";
import {
  init_AlarmOutline
} from "./chunk-MQZSBSPD.mjs";
import {
  __esm
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/index.ts
var init_icons = __esm({
  "src/icons/index.ts"() {
    init_AddCircleFilled();
    init_AddCircleOutline();
    init_Add();
    init_AddressBookFilled();
    init_AddressBookOutline();
    init_AlarmFilled();
    init_AlarmOutline();
    init_AlertFilled();
    init_AlertOutline();
    init_ArrowDown();
    init_ArrowLeftDown();
    init_ArrowLeft();
    init_ArrowLeftUp();
    init_ArrowRightDown();
    init_ArrowRight();
    init_ArrowRightUp();
    init_ArrowUp();
    init_BellFilled();
    init_BellOutline();
    init_BinFilled();
    init_BinOutline();
    init_BlockedFilled();
    init_BlockedOutline();
    init_BookmarkFilled();
    init_BookmarkOutline();
    init_BottleFilled();
    init_BottleOutline();
    init_BrowserFilled();
    init_BrowserOutline();
    init_BuildingFilled();
    init_BuildingOutline();
    init_CakeFilled();
    init_CakeOutline();
    init_CalendarFilled();
    init_CalendarOutline();
    init_CardFilled();
    init_CardOutline();
    init_CartFilled();
    init_CartOutline();
    init_ChartBarFilled();
    init_ChartBarOutline();
    init_ChartGrowthFilled();
    init_ChartGrowthOutline();
    init_ChartPieFilled();
    init_ChartPieOutline();
    init_ChatFilled();
    init_ChatGroupFilled();
    init_ChatGroupOutline();
    init_ChatOutline();
    init_ChatSmileFilled();
    init_ChatSmileOutline();
    init_ChatSuccessFilled();
    init_ChatSuccessOutline();
    init_CheckListFilled();
    init_ChevronDown();
    init_ChevronLeft();
    init_ChevronRight();
    init_ChevronSmallDown();
    init_ChevronSmallLeft();
    init_ChevronSmallRight();
    init_ChevronSmallUp();
    init_ChevronUp();
    init_ClockFilled();
    init_ClockOutline();
    init_ClosedFilled();
    init_ClosedOutline();
    init_Close();
    init_CocktailFilled();
    init_CocktailOutline();
    init_CoffeeFilled();
    init_CoffeeOutline();
    init_CoinFilled();
    init_CoinOutline();
    init_CopyFilled();
    init_CopyOutline();
    init_CouponFilled();
    init_CouponOutline();
    init_CrownFilled();
    init_CrownOutline();
    init_CutleryAltFilled();
    init_CutleryAltOutline();
    init_CutleryFilled();
    init_CutleryOutline();
    init_DiscountFilled();
    init_DiscountOutline();
    init_DocWarningFilled();
    init_DocWarningOutline();
    init_DownloadCloudFilled();
    init_DownloadCloudOutline();
    init_DownloadFilled();
    init_DownloadOutline();
    init_DraggableFilled();
    init_EditFilled();
    init_EditOutline();
    init_ErrorFilled();
    init_ErrorOutline();
    init_ExpandFilled();
    init_ExternalLinkFilled();
    init_ExternalLinkOutline();
    init_EyeOff2Outline();
    init_EyeOffFilled();
    init_EyeOffOutline();
    init_EyeOnFilled();
    init_EyeOnOutline();
    init_FilterFilled();
    init_FilterOutline();
    init_FlagFilled();
    init_FlagOutline();
    init_FolderFilled();
    init_FolderInfoFilled();
    init_FolderInfoOutline();
    init_FolderOutline();
    init_ForwardFilled();
    init_ForwardOutline();
    init_GiftFilled();
    init_GiftOutline();
    init_GiveFilled();
    init_GiveOutline();
    init_GlutenFreeFilled();
    init_GlutenFreeOutline();
    init_GridFilled();
    init_GridOutline();
    init_Hashtag();
    init_HeartFilled();
    init_HeartOutline();
    init_HistoryFilled();
    init_HistoryOutline();
    init_HomeFilled();
    init_HomeOutline();
    init_HotelFilled();
    init_HotelOutline();
    init_ImageAddFilled();
    init_ImageAddOutline();
    init_ImportPosFilled();
    init_ImportPosOutline();
    init_InfoFilled();
    init_InfoOutline();
    init_KeyFilled();
    init_KeyOutline();
    init_KnifeFilled();
    init_KnifeOutline();
    init_LeafFilled();
    init_LeafOutline();
    init_LightbulbFilled();
    init_LightbulbOutline();
    init_LinkOutline();
    init_LinkUnlinkOutline();
    init_ListCheck3Filled();
    init_ListIndefiniteFilled();
    init_ListSettingsFilled();
    init_LockFilled();
    init_LockOutline();
    init_LoginFilled();
    init_LoginOutline();
    init_LogoutFilled();
    init_LogoutOutline();
    init_MailAddFilled();
    init_MailAddOutline();
    init_MailFilled();
    init_MailOutline();
    init_MapFilled();
    init_MapOutline();
    init_MapPinFilled();
    init_MapPinOutline();
    init_MapPinsFilled();
    init_MapPinsOutline();
    init_MenuAlt();
    init_Menu();
    init_MinusCircleFilled();
    init_MinusCircleOutline();
    init_Minus();
    init_MoreHorizontal();
    init_MoreVertical();
    init_NavFilled();
    init_NavOutline();
    init_NutFilled();
    init_NutOutline();
    init_PageFilled();
    init_PageOutline();
    init_PaperFilled();
    init_PaperOutline();
    init_PercentageFilled();
    init_PercentageOutline();
    init_PhoneFilled();
    init_PhoneOutline();
    init_PinFilled();
    init_PinOutline();
    init_PrinterCloudFilled();
    init_PrinterCloudOutline();
    init_PrinterFilled();
    init_PrinterOutline();
    init_PrivacyFilled();
    init_PrivacyOutline();
    init_QrCodeFilled();
    init_QrCodeOutline();
    init_QuestionFilled();
    init_QuestionOutline();
    init_ReceiptAltFilled();
    init_ReceiptAltOutline();
    init_ReceiptFilled();
    init_ReceiptOutline();
    init_RefreshFilled();
    init_RefreshOutline();
    init_ScaleFilled();
    init_ScaleOutline();
    init_ScanFilled();
    init_ScanOutline();
    init_SearchFilled();
    init_SearchOutline();
    init_SecureFilled();
    init_SecureOutline();
    init_SendFilled();
    init_SendOutline();
    init_SettingsFilled();
    init_SettingsOutline();
    init_ShareFilled();
    init_ShareOutline();
    init_ShieldFilled();
    init_ShieldOutline();
    init_ShoppingBagFilled();
    init_ShoppingBagOutline();
    init_SidebarFilled();
    init_SidebarOutline();
    init_SortAscOutline();
    init_SortDescOutline();
    init_SparkleFilled();
    init_SparkleOutline();
    init_StarFilled();
    init_StarHalf();
    init_StarOutline();
    init_StopFilled();
    init_StopOutline();
    init_SuccessFilled();
    init_SuccessOutline();
    init_SupportFilled();
    init_SupportOutline();
    init_TagFilled();
    init_TagOutline();
    init_TakeAwayFilled();
    init_TakeAwayOutline();
    init_ThumbsDownFilled();
    init_ThumbsDownOutline();
    init_ThumbsUpFilled();
    init_ThumbsUpOutline();
    init_Tick();
    init_TimerFilled();
    init_TimerOutline();
    init_UndoFilled();
    init_UndoOutline();
    init_UnlockFilled();
    init_UnlockOutline();
    init_UploadCloudFilled();
    init_UploadCloudOutline();
    init_UploadFilled();
    init_UploadOutline();
    init_UserAddFilled();
    init_UserAddOutline();
    init_UserCircleFilled();
    init_UserCircleOutline();
    init_UserFilled();
    init_UserFollowFilled();
    init_UserFollowOutline();
    init_UserGroupFilled();
    init_UserGroupOutline();
    init_UserOutline();
    init_UserRemoveFilled();
    init_UserRemoveOutline();
    init_UserVipFilled();
    init_UserVipOutline();
    init_VeganFilled();
    init_VeganOutline();
    init_VegetarianFilled();
    init_VegetarianOutline();
    init_VenueFilled();
    init_VenueOutline();
    init_WalletFilled();
    init_WalletOutline();
    init_WarningFilled();
    init_WarningOutline();
    init_WorldFilled();
    init_WorldOutline();
    init_ZoomInFilled();
    init_ZoomInOutline();
    init_ZoomOutFilled();
    init_ZoomOutOutline();
  }
});

export {
  init_icons
};
